import React from 'react';
import useClassname from '../Core/hooks/use-classname';

export interface IBaseElementProps {
	/** Replaces the class name for component */
	className?: string;
	/** Adds other class names to component */
	classNames?: string[];
	children?: React.ReactNode;
	/** Sets the id for the component. Useful for anchor tags. */
	id?: string;
}

export const baseElementProps = ({
	id,
	className,
	classNames = [],
	...otherProps
}: IBaseElementProps) => {
	const props = useClassname({ className, classNames });
	if (id) {
		props.id = id;
	}
	return { props, ...otherProps };
};

/**
 * Basic Element description
 * @name Basic Element
 * @icon my-icon
 * @param props IBaseElementProps
 */
const BasicElement: React.FC<IBaseElementProps> = ({ children, ...props }) => {
	return <div {...baseElementProps(props)}>{children}</div>;
};

export default BasicElement;
